import {CircularProgress, Grid} from "@mui/material";
import {Skeleton} from "@mui/lab";
import React from "react";
import {makeStyles} from "@mui/styles";
import Backdrop from "@mui/material/Backdrop";

let skeletonRowsPool = [
    [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
    [2, 2, 2, 2, 2, 2],
    [3, 3, 3, 3],
    [4, 4, 4],
    [5, 2, 5],
    [6, 6],
    [12],
    [1, 3, 5, 3,],
    [2, 4, 6,],
    [1, 2, 1, 4, 2, 2,],
    [2, 2, 2, 6,],
    [2, 10,],
    [5, 7,],
];

const useStyles = makeStyles((theme) => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
}));

function getRandomSkeletonRow() {
    let idx = Math.floor(Math.random() * Math.floor(skeletonRowsPool.length)); //NOSONAR - ignore security issue with Math.random(), this is not a critical hotspot
    return skeletonRowsPool[idx];
}

export function SkeletonText({rows, withHeadline}) {
    let skeletonRows = React.useMemo(() => Array(rows ?? 10)
        .fill(0)
        .map(() => getRandomSkeletonRow()), [rows])

    return <Grid container spacing={2}>
        {withHeadline &&
            <Grid item xs={12}>
                <Skeleton variant={'text'} height={30}>
                    <span/>
                </Skeleton>
            </Grid>
        }
        {
            skeletonRows.map((r, j) =>
                <Grid item xs={12} key={j}>
                    <Grid container spacing={2}>
                        {r.map((e, i) => <Grid key={j + '-' + i} item xs={e}>
                            <Skeleton variant={'text'} height={10}>
                                <span/>
                            </Skeleton>
                        </Grid>)
                        }
                    </Grid>
                </Grid>
            )
        }
    </Grid>;

}

export function FullSizeText({text}) {
    return <Grid container justifyContent={'center'} alignItems={'center'} spacing={1} direction="row"
                 style={{height: '100%'}}>
        <Grid item xs={12} align={'center'}>
            <b>{text}</b>
        </Grid>
    </Grid>
}

let dimensions = (hasText, shrink) => {
    let left = 6

    if (shrink) {
        left = 4
    }

    if (!hasText) {
        left = 12
    }

    return {left, right: 12 - left}
}

export function FullSizeIconWithText({icon, text, shrinkLeft}) {
    let {left, right} = dimensions(text, shrinkLeft)
    return <Grid container justifyContent={'center'} alignItems={'center'} spacing={1} direction="row"
                 style={{height: '100%'}}>
        <Grid item xs={left} align={text ? 'right' : 'center'}>
            {icon}
        </Grid>
        {text &&
            <Grid item xs={right} align={'left'}>
                <b>{text}</b>
            </Grid>
        }
    </Grid>
}

export function CenteredLoader({icon, text, iconSize}) {
    iconSize = iconSize ?? 50;
    icon = icon ?? <CircularProgress color={"inherit"} size={iconSize}/>;
    text = text ?? '';

    return <FullSizeIconWithText icon={icon} text={text}/>;
}


export function BackdropLoader(props) {
    let classes = useStyles();

    let text = props.text ?? '';

    return <Backdrop open={true} className={classes.backdrop}>
        <CenteredLoader text={text}/>
    </Backdrop>

}